import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes, SubmissionError } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { required } from '../../ReduxForm/validation';
import {
  ReduxFormField,
  ReduxFormError,
  ReduxFormSubmitButton,
} from '../Forms/index';

import './styles.scss';

class _ResetPasswordForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    onResetPassword: PropTypes.func.isRequired,
  };

  state = {
    success: false,
    emailAddress: null,
  };

  onSubmit = ({ email }) => {
    const { onResetPassword } = this.props;
    this.setState({ success: false, emailAddress: null });
    return onResetPassword(email).then(
      (emailAddress) => {
        this.setState({ success: true, emailAddress });
      },
      (error) => {
        throw new SubmissionError({ _error: error.message });
      }
    );
  };

  render() {
    const { success, emailAddress } = this.state;
    const { handleSubmit, submitting, error, t } = this.props;

    // id=reset-password-form required to override some portal theme css
    return (
      <div id="reset-password-form">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          {success && emailAddress ? (
            <>
              <h2>Reset password success</h2>
              <p>
                Please check your email for instructions on how to reset your
                password.
              </p>
            </>
          ) : (
            <>
              <h2>{t('reset_your_password')}</h2>
              <p>
                Enter your email or profile name below. We will send you
                instructions on how to reset your password.
              </p>
              <Field
                name="email"
                type="text"
                label="Email or profile name"
                component={ReduxFormField}
                validate={required}
              />
              {error && <ReduxFormError error={error} />}
              <ReduxFormSubmitButton label="Send" {...{ submitting }} />
            </>
          )}
        </form>
      </div>
    );
  }
}

export const ResetPasswordForm = withTranslation(['auth'])(
  reduxForm({
    form: 'resetPassword',
  })(_ResetPasswordForm)
);

export const ModalResetPasswordForm = withTranslation(['auth'])(
  reduxForm({
    form: 'modalResetPassword',
  })(_ResetPasswordForm)
);
